const hu = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Betöltés...',
    error: 'Hiba',
    save: 'Mentés',
    cancel: 'Mégse',
    delete: 'Törlés',
    edit: 'Szerkesztés',
    create: 'Létrehozás',
    add: 'Hozzáadás',
    remove: 'Eltávolítás',
    close: 'Bezárás',
    confirm: 'Megerősítés',
    apply: 'Alkalmazás',
    reset: 'Visszaállítás',
    search: 'Keresés',
    filter: 'Szűrő',
    clear: 'Törlés',
    back: 'Vissza',
    next: 'Következő',
    previous: 'Előző',
    submit: 'Beküldés',
    update: 'Frissítés',
    refresh: 'Frissítés',
    export: 'Exportálás',
    import: 'Importálás',
    download: 'Letöltés',
    upload: 'Feltöltés',
    print: 'Nyomtatás',
    copy: 'Másolás',
    yes: 'Igen',
    no: 'Nem',
    ok: 'OK',
    done: 'Kész',
    select: 'Kiválasztás',
    selectAll: 'Összes kijelölése',
    deselectAll: 'Kijelölés megszüntetése',
    noResults: 'Nincs találat',
    noData: 'Nincs elérhető adat',
    required: 'Kötelező',
    optional: 'Opcionális',
    actions: 'Műveletek',
    details: 'Részletek',
    overview: 'Áttekintés',
    summary: 'Összefoglaló',
    total: 'Összesen',
    all: 'Összes',
    none: 'Nincs',
    name: 'Név',
    type: 'Típus',
    status: 'Állapot',
    date: 'Dátum',
    time: 'Idő',
    description: 'Leírás',
    notes: 'Megjegyzések',
    comments: 'Hozzászólások',
    category: 'Kategória',
    priority: 'Prioritás',
    nation: 'Állam',
    country: 'Ország',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Cím',
    location: 'Helyszín',
    coordinates: 'Koordináták',
    latitude: 'Szélesség',
    longitude: 'Hosszúság',
    from: 'Feladó',
    to: 'Címzett',
    createdAt: 'Létrehozva',
    updatedAt: 'Frissítve',
    createdBy: 'Létrehozta',
    modifiedBy: 'Módosította',
    active: 'Aktív',
    inactive: 'Inaktív',
    enabled: 'Engedélyezve',
    disabled: 'Letiltva',
    showing: 'Megjelenítve',
    of: '/',
    page: 'Oldal',
    perPage: 'oldalanként',
    rows: 'sor',
    items: 'elem',
    results: 'találat',
    sortBy: 'Rendezés',
    ascending: 'Növekvő',
    descending: 'Csökkenő',
    viewAll: 'Összes megtekintése',
    viewDetails: 'Részletek megtekintése',
    goBack: 'Vissza',
    learnMore: 'Tudjon meg többet',
    seeMore: 'Továbbiak',
    showMore: 'Továbbiak megjelenítése',
    showLess: 'Kevesebb megjelenítése',
    expandAll: 'Összes kibontása',
    collapseAll: 'Összes összecsukása',
    copied: 'Másolva!',
    saved: 'Mentve!',
    deleted: 'Törölve!',
    updated: 'Frissítve!',
    created: 'Létrehozva!',
    success: 'Sikeres',
    warning: 'Figyelmeztetés',
    info: 'Információ',
    danger: 'Veszély',
    unknown: 'Ismeretlen',
    notAvailable: 'Nem elérhető',
    never: 'Soha',
    today: 'Ma',
    yesterday: 'Tegnap',
    tomorrow: 'Holnap',
    now: 'Most',
    ago: 'ezelőtt',
    justNow: 'most',
    minutesAgo: '{{count}} perce',
    hoursAgo: '{{count}} órája',
    daysAgo: '{{count}} napja',
    monthsAgo: '{{count}} hónapja',
    id: 'ID',
    version: 'Verzió',
    language: 'Nyelv',
    theme: 'Téma',
    darkMode: 'Sötét mód',
    lightMode: 'Világos mód',
    failedToLoad: 'Az adatok betöltése sikertelen',
    failedToSave: 'A mentés sikertelen',
    failedToDelete: 'A törlés sikertelen',
    failedToUpdate: 'A frissítés sikertelen',
    confirmDelete: 'Biztosan törölni szeretné?',
    confirmAction: 'Biztosan folytatja?',
    unsavedChanges: 'Mentetlen módosításai vannak. Biztosan el szeretne navigálni?',
    pageNotFound: '404 – Az oldal nem található',
    pageNotFoundDesc: 'A keresett oldal nem létezik.',
    backToDashboard: 'Vissza az áttekintéshez',
    characters: 'karakter',
    maxCharacters: 'Maximum {{max}} karakter',
    remaining: '{{count}} maradt',
    selected: '{{count}} kiválasztva',
    of_total: '{{count}} / {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Áttekintés',
    requests: 'Kérelmek',
    transports: 'Szállítások',
    myPatients: 'Betegeim',
    statistics: 'Statisztikák',
    flow: 'Folyamat',
    resources: 'Resources',
    exercise: 'Gyakorlat',
    administration: 'Adminisztráció',
    map: 'Térkép',
    info: 'Információ',
    users: 'Felhasználók',
    assets: 'Eszközök',
    hubs: 'Csomópontok',
    treatmentFacilities: 'Egészségügyi létesítmények',
    patientImport: 'Betegimportálás',
    assetTemplates: 'Eszközsablonok',
    dayTemplates: 'Napi sablonok',
    announcementTicker: 'Közleménysor',
    exerciseStatistics: 'Gyakorlat statisztikái',
    settings: 'Beállítások',
    auditLog: 'Naplózás',
    exerciseControl: 'Gyakorlat vezérlése',
    dataSync: 'Adatszinkronizálás',
    documentation: 'Dokumentáció',
    support: 'Támogatás',
    about: 'Névjegy',
    assetContracts: 'Asset Contracts',
    notifications: 'Értesítések',
    schedules: 'Menetrendek',
    capacityPlanning: 'Kapacitástervezés',
    transportPlanning: 'Szállítástervezés',
    transportBooking: 'Szállításfoglalás',
    flowDiagram: 'Folyamatábra',
    changePassword: 'Jelszó módosítása',
    missions: 'Küldetések',
    startPoints: 'Kiindulópontok',
    hospital: 'Kórház',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Bejelentkezés',
    logout: 'Kijelentkezés',
    logoutNow: 'Kijelentkezés most',
    loggingIn: 'Bejelentkezés...',
    loginFailed: 'A bejelentkezés sikertelen',
    email: 'E-mail',
    password: 'Jelszó',
    username: 'Felhasználónév',
    enterEmail: 'Adja meg e-mail címét',
    enterPassword: 'Adja meg jelszavát',
    enterUsername: 'Adja meg felhasználónevét',
    forgotPassword: 'Elfelejtett jelszó?',
    forgotPasswordTitle: 'Elfelejtett jelszó',
    forgotPasswordDesc: 'Adja meg felhasználónevét és e-mail címét. Ha mindkettő egyezik, az adminisztrátorok értesítést kapnak a jelszó visszaállításáról.',
    requestPasswordReset: 'Jelszó-visszaállítás kérése',
    sending: 'Küldés...',
    backToLogin: 'Vissza a bejelentkezéshez',
    pleaseWait: 'Kérjük, várjon az újrapróbálkozás előtt.',
    requestFailed: 'A kérés sikertelen',
    credentialsMatch: 'Ha az adatok egyeznek, az adminisztrátorok értesítést kaptak.',
    forAccess: 'Hozzáférésért kérjük, forduljon a rendszergazdához.',
    changePassword: 'Jelszó módosítása',
    currentPassword: 'Jelenlegi jelszó',
    newPassword: 'Új jelszó',
    confirmPassword: 'Jelszó megerősítése',
    passwordChanged: 'A jelszó sikeresen módosítva',
    passwordMismatch: 'A jelszavak nem egyeznek',
    passwordTooShort: 'A jelszónak legalább 8 karakter hosszúnak kell lennie',
    changingPassword: 'Módosítás...',
    mustChangePassword: 'A folytatás előtt módosítania kell jelszavát.',
    sessionExpiring: 'A munkamenet lejár',
    sessionExpireText: 'Munkamenete <strong>{{time}}</strong> múlva lejár. Kérjük, mentse munkáját, és jelentkezzen be újra.',
    dismiss: 'Bezárás',
    switchNation: 'Állam váltása',
    returnTo: 'Visszatérés: {{nation}}',
    viewingAs: 'Megtekintés mint',
    loggedInAs: 'bejelentkezve mint {{nation}}',
    trainingMode: 'KIZÁRÓLAG GYAKORLATI CÉLOKRA',
    dedication: 'Szeretettel és a hivatás iránti elkötelezettséggel készült',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Rendszergazda',
    excon: 'Gyakorlatvezető',
    eu: 'EU-koordinátor',
    planner: 'Tervező',
    hub: 'Csomópont-kezelő',
    nation: 'Állam',
    readOnly: 'Csak olvasható',
    systemAdmin: 'Rendszergazda',
    transportPlanner: 'Szállítástervező',
    systemRoles: 'Rendszerszerepek',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Vázlat',
    underReview: 'Felülvizsgálat alatt',
    published: 'Közzétéve',
    underSelection: 'Kiválasztás alatt',
    accepted: 'Elfogadva',
    planned: 'Tervezett',
    inTransit: 'Úton',
    completed: 'Befejezve',
    closed: 'Lezárva',
    withdrawn: 'Visszavonva',
    pending: 'Függőben',
    rejected: 'Elutasítva',
    cancelled: 'Törölve',
    active: 'Aktív',
    inactive: 'Inaktív',
    review: 'Felülvizsgálat',
    selection: 'Kiválasztás',
    transit: 'Úton',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Személyzet',
    material: 'Anyag',
    equipment: 'Felszerelés',
    other: 'Egyéb',
    news: 'Hírek',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Rutin',
    priority: 'Kiemelt',
    urgent: 'Sürgős',
    immediate: 'Azonnali',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Vonat',
    ship: 'Hajó',
    aircraft: 'Repülőgép',
    bus: 'Busz',
    ambulance: 'Mentőautó',
    drone: 'Drón',
    helicopter: 'Helikopter',
    ferry: 'Komp',
    other: 'Egyéb',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Áttekintés',
    goodMorning: 'Jó reggelt',
    goodAfternoon: 'Jó napot',
    goodEvening: 'Jó estét',
    lastLogin: 'Utolsó bejelentkezés',
    infrastructure: 'Infrastruktúra',
    transportAssets: 'Szállítási eszközök',
    treatmentFacilities: 'Egészségügyi létesítmények',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Kérelem statisztikák',
    viewAllRequests: 'Összes kérelem megtekintése',
    availableAssets: 'Elérhető eszközök',
    seated: 'Ülő',
    lying: 'Fekvő',
    intensive: 'Intenzív',
    notifications: 'Értesítések',
    markAllRead: 'Összes olvasottnak jelölése',
    noNotifications: 'Még nincsenek értesítések',
    notifiedWhenActivity: 'Értesítést kap, ha új tevékenység történik',
    viewDetailsBtn: 'Részletek megtekintése',
    nationUsers: 'Állami felhasználók',
    user: 'Felhasználó',
    roles: 'Szerepek',
    noUsersFound: 'Nem találhatók felhasználók',
    participatingNations: 'Résztvevő államok',
    exerciseDisclaimer: 'Ez a rendszer kizárólag gyakorlati célokra szolgál. Csak szimulált gyakorlati adatokat adjon meg. A munkafolyamatok a gyakorlati forgatókönyvhöz igazodnak, és eltérhetnek a valós eljárásoktól. Az informatikai biztonsági és adatvédelmi szabályok teljes mértékben érvényben maradnak.',
    notConfigured: 'Nincs konfigurálva',
    requestCount: '{{count}} kérelem',
    clickToView: 'Kattintson a megtekintéshez',
    systemAdministration: 'Rendszeradminisztráció',
    exerciseControlTitle: 'Gyakorlat vezérlése',
    euCoordination: 'EU-koordináció',
    transportPlanningTitle: 'Szállítástervezés',
    hubManagement: 'Csomópont-kezelés',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Új kérelem',
    myDrafts: 'Vázlataim',
    pendingReview: 'Felülvizsgálatra vár',
    activeTransports: 'Aktív szállítások',
    myPatients: 'Betegeim',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Kérelmek',
    newRequest: 'Új kérelem',
    createRequest: 'Kérelem létrehozása',
    editRequest: 'Kérelem szerkesztése',
    requestDetail: 'Kérelem részletei',
    requestId: 'Kérelem azonosító',
    fromNation: 'Küldő állam',
    toNation: 'Fogadó állam',
    requestingNation: 'Kérelmező állam',
    receivingNation: 'Fogadó állam',
    category: 'Kategória',
    urgency: 'Sürgősség',
    status: 'Állapot',
    patients: 'Betegek',
    patientCount: 'Betegek száma',
    offers: 'Ajánlatok',
    offerCount: 'Ajánlatok száma',
    created: 'Létrehozva',
    updated: 'Frissítve',
    submittedBy: 'Beküldte',
    reviewedBy: 'Felülvizsgálta',
    description: 'Leírás',
    medicalDetails: 'Orvosi adatok',
    transportDetails: 'Szállítási adatok',
    additionalInfo: 'További információk',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Indulási pont',
    arrivalPoint: 'Érkezési pont',
    estimatedDeparture: 'Tervezett indulás',
    estimatedArrival: 'Tervezett érkezés',
    submitForReview: 'Beküldés felülvizsgálatra',
    publish: 'Közzététel',
    startSelection: 'Kiválasztás indítása',
    acceptOffer: 'Ajánlat elfogadása',
    markInTransit: 'Megjelölés úton lévőként',
    markCompleted: 'Megjelölés befejezettként',
    closeRequest: 'Kérelem lezárása',
    withdrawRequest: 'Kérelem visszavonása',
    withdraw: 'Visszavonás',
    revertToDraft: 'Visszaállítás vázlattá',
    deleteRequest: 'Kérelem törlése',
    duplicateRequest: 'Kérelem másolása',
    createFollowUp: 'Konszolidált kérelem létrehozása',
    followUpRequest: 'Konszolidált kérelem',
    parentRequest: 'Eredeti kérelem',
    childRequests: 'Konszolidált kérelmek',
    noRequests: 'Nem találhatók kérelmek',
    noOffers: 'Még nincsenek ajánlatok',
    addPatient: 'Beteg hozzáadása',
    removePatient: 'Beteg eltávolítása',
    patientDetails: 'Beteg adatai',
    contactPerson: 'Kapcsolattartó',
    contactPhone: 'Kapcsolattartó telefonja',
    contactEmail: 'Kapcsolattartó e-mailje',
    specialRequirements: 'Speciális követelmények',
    medicalEquipment: 'Orvosi felszerelés',
    accompaniment: 'Kísérés',
    timeline: 'Idővonal',
    history: 'Előzmények',
    addComment: 'Hozzászólás hozzáadása',
    writeComment: 'Írjon hozzászólást...',
    postComment: 'Hozzászólás küldése',
    posting: 'Küldés...',
    noComments: 'Még nincsenek hozzászólások',
    coverageBar: 'Lefedettség',
    covered: 'lefedett',
    uncovered: 'nem lefedett',
    filterByStatus: 'Szűrés állapot szerint',
    filterByCategory: 'Szűrés kategória szerint',
    filterByNation: 'Szűrés állam szerint',
    searchRequests: 'Kérelmek keresése...',
    confirmWithdraw: 'Biztosan visszavonja ezt a kérelmet?',
    confirmDelete: 'Biztosan törölni szeretné ezt a kérelmet?',
    confirmPublish: 'Biztosan közzé szeretné tenni ezt a kérelmet? Minden állam számára láthatóvá válik.',
    confirmStartSelection: 'Biztosan elindítja a kiválasztást? Az államok ajánlatokat tehetnek.',
    warningStartSelection: 'A kiválasztás elindítása ezt a kérelmet minden résztvevő állam számára láthatóvá teszi. Ajánlatokat tehetnek a kérelemben szereplő betegekre. Ez a művelet nem vonható vissza.',
    warningMakeOffer: 'Az ajánlat benyújtásával az Ön állama vállalja a javasolt segítségnyújtást. Ez a művelet értesíti a kérelmező államot és a gyakorlatvezetőt.',
    saveDraft: 'Vázlat mentése',
    saving: 'Mentés...',
    saveAndSubmit: 'Mentés és beküldés',
    step: '{{number}}. lépés',
    generalInfo: 'Általános információk',
    patientInfo: 'Beteg információi',
    logisticsInfo: 'Logisztikai információk',
    reviewSubmit: 'Felülvizsgálat és beküldés',
    requestTitle: 'Kérelem címe',
    requestDescription: 'Kérelem leírása',
    numberOfPatients: 'Betegek száma',
    typeOfAssistance: 'Segítség típusa',
    medicalTreatment: 'Orvosi kezelés',
    transportAssistance: 'Szállítási segítség',
    both: 'Mindkettő',
    treatmentOnly: 'Csak kezelés',
    transportOnly: 'Csak szállítás',
    validationErrors: 'Kérjük, javítsa a következő hibákat:',
    fieldRequired: 'Ez a mező kötelező',
    selectExitHub: 'Válasszon kilépési csomópontot',
    createExitHub: 'Kilépési csomópont létrehozása',
    backToRequests: 'Vissza a kérelmekhez',
    noRequestsFound: 'Nem találhatók kérelmek',
    createFirstRequest: 'Hozza létre első kérelmét a kezdéshez',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ajánlatok',
    createOffer: 'Ajánlat létrehozása',
    makeOffer: 'Ajánlat benyújtása',
    manageOffers: 'Ajánlatok kezelése',
    offerDetail: 'Ajánlat részletei',
    offerId: 'Ajánlat azonosító',
    offeringNation: 'Ajánló állam',
    offerType: 'Ajánlat típusa',
    treatment: 'Kezelés',
    transport: 'Szállítás',
    combined: 'Kombinált',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Kezelési ajánlat',
    transportOffer: 'Szállítási ajánlat',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Betegek kiválasztása',
    selectedPatients: 'Kiválasztott betegek',
    patientSelection: 'Beteg kiválasztása',
    offerConfiguration: 'Ajánlat konfigurációja',
    reviewOffer: 'Ajánlat felülvizsgálata',
    submitOffer: 'Ajánlat beküldése',
    submitting: 'Beküldés...',
    acceptOffer: 'Ajánlat elfogadása',
    rejectOffer: 'Ajánlat elutasítása',
    withdrawOffer: 'Ajánlat visszavonása',
    noOffers: 'Nincsenek elérhető ajánlatok',
    noOffer: 'No Offer',
    offerStatus: 'Ajánlat állapota',
    offerDate: 'Ajánlat dátuma',
    transportAsset: 'Szállítási eszköz',
    departureDate: 'Indulás dátuma',
    arrivalDate: 'Érkezés dátuma',
    treatmentFacility: 'Egészségügyi létesítmény',
    capacity: 'Kapacitás',
    availableCapacity: 'Elérhető kapacitás',
    totalCapacity: 'Teljes kapacitás',
    selectAsset: 'Eszköz kiválasztása',
    selectFacility: 'Létesítmény kiválasztása',
    offerNotes: 'Ajánlat megjegyzései',
    confirmAccept: 'Biztosan elfogadja ezt az ajánlatot?',
    confirmReject: 'Biztosan elutasítja ezt az ajánlatot?',
    extendTransport: 'Szállítás kiterjesztése',
    transportExtension: 'Szállítás kiterjesztése',
    comparisonView: 'Összehasonlítás',
    shortlist: 'Szűkített lista',
    addToShortlist: 'Hozzáadás a szűkített listához',
    removeFromShortlist: 'Eltávolítás a szűkített listáról',
    leaveConfirmTitle: 'Elhagyja ezt az oldalt?',
    leaveConfirmMessage: 'Mentetlen módosításai vannak. Biztosan el szeretne navigálni?',
    stayOnPage: 'Maradás az oldalon',
    leavePage: 'Oldal elhagyása',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Szállítások',
    missionDetail: 'Szállítás részletei',
    missionId: 'Szállítás azonosító',
    missionStatus: 'Szállítás állapota',
    createMission: 'Szállítás létrehozása',
    overview: 'Áttekintés',
    patientsTab: 'Betegek',
    transportsTab: 'Szállítási szakaszok',
    treatmentTab: 'Kezelés',
    reviewTab: 'Felülvizsgálat',
    departure: 'Indulás',
    arrival: 'Érkezés',
    origin: 'Kiindulópont',
    destination: 'Célállomás',
    stops: 'Megállók',
    addStop: 'Megálló hozzáadása',
    removeStop: 'Megálló eltávolítása',
    stopName: 'Megálló neve',
    stopType: 'Megálló típusa',
    estimatedTime: 'Becsült idő',
    actualTime: 'Tényleges idő',
    asset: 'Eszköz',
    driver: 'Vezető',
    crew: 'Személyzet',
    noMissions: 'Nem találhatók szállítások',
    completeMission: 'Szállítás befejezése',
    cancelMission: 'Szállítás törlése',
    startTransport: 'Szállítás indítása',
    missionChain: 'Szállítási lánc',
    linkedMissions: 'Kapcsolt szállítások',
    handover: 'Átadás',
    handoverPoint: 'Átadási pont',
    pickupPoint: 'Felvételi pont',
    dropoffPoint: 'Leadási pont',
    searchTransports: 'Szállítások keresése...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Betegek',
    myPatients: 'Betegeim',
    patientId: 'Beteg azonosító',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    dateOfBirth: 'Születési dátum',
    age: 'Kor',
    gender: 'Nem',
    male: 'Férfi',
    female: 'Nő',
    other: 'Egyéb',
    nationality: 'Állampolgárság',
    diagnosis: 'Diagnózis',
    condition: 'Állapot',
    stable: 'Stabil',
    critical: 'Kritikus',
    serious: 'Súlyos',
    treatmentNeeded: 'Szükséges kezelés',
    allergies: 'Allergiák',
    medications: 'Gyógyszerek',
    bloodType: 'Vércsoport',
    weight: 'Testsúly (kg)',
    infectious: 'Fertőző',
    mentalHealth: 'Mentális egészség',
    mobility: 'Mobilitás',
    ambulatory: 'Járóképes',
    wheelchair: 'Kerekesszék',
    stretcher: 'Hordágy',
    intensive: 'Intenzív ellátás',
    oxygenRequired: 'Oxigén szükséges',
    ventilator: 'Lélegeztetőgép',
    medicalEscort: 'Orvosi kíséret',
    noPatients: 'Nem találhatók betegek',
    patientDetails: 'Beteg adatai',
    medicalHistory: 'Kórtörténet',
    travelDocuments: 'Utazási okmányok',
    passport: 'Útlevél',
    pseudonymizedId: 'Álnevesített azonosító',
    sensitiveData: 'Érzékeny adatok',
    journey: 'Beteg útja',
    assignedTo: 'Hozzárendelve',
    currentLocation: 'Jelenlegi helyszín',
    importPatients: 'Betegek importálása',
    exportPatients: 'Betegek exportálása',
    seated: 'Ülő',
    lying: 'Fekvő',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Felhasználók',
    createUser: 'Felhasználó létrehozása',
    editUser: 'Felhasználó szerkesztése',
    deleteUser: 'Felhasználó törlése',
    username: 'Felhasználónév',
    displayName: 'Megjelenítendő név',
    email: 'E-mail',
    password: 'Jelszó',
    role: 'Szerep',
    roles: 'Szerepek',
    nation: 'Állam',
    active: 'Aktív',
    lastLogin: 'Utolsó bejelentkezés',
    createdAt: 'Létrehozva',
    isNation: 'Állam',
    isEU: 'EU',
    isAdmin: 'Rendszergazda',
    isExcon: 'EXCON',
    isPlanner: 'Tervező',
    isHub: 'Csomópont',
    isReadOnly: 'Csak olvasható',
    noUsers: 'Nem találhatók felhasználók',
    confirmDelete: 'Biztosan törölni szeretné ezt a felhasználót?',
    resetPassword: 'Jelszó visszaállítása',
    generatePassword: 'Jelszó generálása',
    searchUsers: 'Felhasználók keresése...',
    userCreated: 'Felhasználó sikeresen létrehozva',
    userUpdated: 'Felhasználó sikeresen frissítve',
    userDeleted: 'Felhasználó sikeresen törölve',
    selectNation: 'Válasszon államot',
    mustChangePassword: 'Jelszó módosítása kötelező a következő bejelentkezéskor',
    flagImage: 'Zászló kép',
    exportUsers: 'Felhasználók exportálása',
    importUsers: 'Felhasználók importálása',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Eszközök',
    createAsset: 'Eszköz létrehozása',
    editAsset: 'Eszköz szerkesztése',
    deleteAsset: 'Eszköz törlése',
    assetName: 'Eszköz neve',
    assetType: 'Eszköz típusa',
    capacitySeated: 'Kapacitás (ülő)',
    capacityLying: 'Kapacitás (fekvő)',
    capacityIntensive: 'Kapacitás (intenzív)',
    owner: 'Tulajdonos',
    operator: 'Üzemeltető',
    baseLocation: 'Bázis helyszín',
    range: 'Hatótávolság',
    speed: 'Sebesség',
    noAssets: 'Nem találhatók eszközök',
    confirmDelete: 'Biztosan törölni szeretné ezt az eszközt?',
    searchAssets: 'Eszközök keresése...',
    assetCreated: 'Eszköz sikeresen létrehozva',
    assetUpdated: 'Eszköz sikeresen frissítve',
    assetDeleted: 'Eszköz sikeresen törölve',
    exportAssets: 'Eszközök exportálása',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Csomópontok',
    startPoints: 'Kiindulópontok',
    createHub: 'Csomópont létrehozása',
    editHub: 'Csomópont szerkesztése',
    deleteHub: 'Csomópont törlése',
    hubName: 'Csomópont neve',
    hubType: 'Csomópont típusa',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Belépési csomópont',
    airport: 'Repülőtér',
    seaport: 'Kikötő',
    railStation: 'Vasútállomás',
    roadPoint: 'Közúti pont',
    ucpmClassification: 'UCPM besorolás',
    icaoCode: 'ICAO kód',
    iataCode: 'IATA kód',
    noHubs: 'Nem találhatók csomópontok',
    confirmDelete: 'Biztosan törölni szeretné ezt a csomópontot?',
    searchHubs: 'Csomópontok keresése...',
    nationAssignment: 'Állam hozzárendelése',
    assignNations: 'Államok hozzárendelése',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Egészségügyi létesítmények',
    createFacility: 'Létesítmény létrehozása',
    editFacility: 'Létesítmény szerkesztése',
    deleteFacility: 'Létesítmény törlése',
    facilityName: 'Létesítmény neve',
    facilityType: 'Létesítmény típusa',
    hospitalName: 'Kórház neve',
    bedCapacity: 'Ágykapacitás',
    specialties: 'Szakterületek',
    availableBeds: 'Elérhető ágyak',
    totalBeds: 'Összes ágy',
    contactPerson: 'Kapcsolattartó',
    noFacilities: 'Nem találhatók egészségügyi létesítmények',
    confirmDelete: 'Biztosan törölni szeretné ezt a létesítményt?',
    searchFacilities: 'Létesítmények keresése...',
    hubNationAssignment: 'Csomópont-állam hozzárendelés',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Menetrendek',
    createSchedule: 'Menetrend létrehozása',
    editSchedule: 'Menetrend szerkesztése',
    deleteSchedule: 'Menetrend törlése',
    scheduleName: 'Menetrend neve',
    scheduleType: 'Menetrend típusa',
    recurring: 'Ismétlődő',
    oneTime: 'Egyszeri',
    frequency: 'Gyakoriság',
    daily: 'Napi',
    weekly: 'Heti',
    startDate: 'Kezdő dátum',
    endDate: 'Záró dátum',
    departureTime: 'Indulási idő',
    arrivalTime: 'Érkezési idő',
    stops: 'Megállók',
    addStop: 'Megálló hozzáadása',
    noSchedules: 'Nem találhatók menetrendek',
    bookings: 'Foglalások',
    timeline: 'Idővonal',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Értesítések',
    markAllRead: 'Összes olvasottnak jelölése',
    markAsRead: 'Olvasottnak jelölés',
    markAsUnread: 'Olvasatlannak jelölés',
    noNotifications: 'Nincsenek értesítések',
    viewAll: 'Összes értesítés megtekintése',
    settings: 'Értesítési beállítások',
    emailNotifications: 'E-mail értesítések',
    inAppNotifications: 'Alkalmazáson belüli értesítések',
    notifyOn: 'Értesítés a következőkről',
    requestCreated: 'Új kérelem',
    requestPublished: 'Kérelem közzétéve',
    requestClosed: 'Kérelem lezárva',
    requestCompleted: 'Kérelem befejezve',
    commentAdded: 'Új hozzászólás',
    offerReceived: 'Ajánlat érkezett',
    offerAccepted: 'Ajánlat elfogadva',
    statusChanged: 'Állapot módosult',
    selectionStarted: 'Kiválasztás elindult',
    missionCreated: 'Szállítás létrehozva',
    missionStatusUpdated: 'Szállítás frissítve',
    transportPartnerNamed: 'Szállítási partner',
    transportExtensionReceived: 'Szállítás kiterjesztése',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Beállítások',
    general: 'Általános',
    system: 'Rendszer',
    email: 'E-mail',
    sync: 'Szinkronizálás',
    security: 'Biztonság',
    appearance: 'Megjelenés',
    systemName: 'Rendszer neve',
    systemEmail: 'Rendszer e-mail',
    maintenanceMode: 'Karbantartási mód',
    readOnlyMode: 'Csak olvasható mód',
    emailEnabled: 'E-mail engedélyezve',
    smtpHost: 'SMTP kiszolgáló',
    smtpPort: 'SMTP port',
    smtpUser: 'SMTP felhasználó',
    smtpPassword: 'SMTP jelszó',
    senderEmail: 'Feladó e-mail',
    senderName: 'Feladó neve',
    testEmail: 'Teszt e-mail küldése',
    syncEnabled: 'Szinkronizálás engedélyezve',
    syncUrl: 'Szinkronizálás URL',
    syncApiKey: 'Szinkronizálás API kulcs',
    settingsSaved: 'Beállítások sikeresen mentve',
    helpdesk: 'Ügyfélszolgálat',
    helpdeskTitle: 'Ügyfélszolgálat neve',
    helpdeskEmail: 'Ügyfélszolgálat e-mail',
    helpdeskPhone: 'Ügyfélszolgálat telefon',
    helpdeskInfo: 'Ügyfélszolgálat információ',
    realLifeSupport: 'Valós támogatás',
    trainingMode: 'Gyakorlati mód',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Naplózás',
    action: 'Művelet',
    user: 'Felhasználó',
    target: 'Cél',
    details: 'Részletek',
    timestamp: 'Időbélyeg',
    ipAddress: 'IP-cím',
    noLogs: 'Nem találhatók naplóbejegyzések',
    searchLogs: 'Naplók keresése...',
    filterByAction: 'Szűrés művelet szerint',
    filterByUser: 'Szűrés felhasználó szerint',
    exportLogs: 'Naplók exportálása',
    exportCsv: 'CSV exportálás',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Gyakorlat vezérlése',
    currentDay: 'Aktuális nap',
    exerciseDay: 'Gyakorlat napja',
    nextDay: 'Következő nap',
    previousDay: 'Előző nap',
    resetExercise: 'Gyakorlat visszaállítása',
    startExercise: 'Gyakorlat indítása',
    endExercise: 'Gyakorlat befejezése',
    dayReset: 'Nap visszaállítása',
    confirmReset: 'Biztosan visszaállítja a gyakorlat napját? Ez törli az aktuális nap összes adatát.',
    resetInProgress: 'Visszaállítás folyamatban...',
    maintenanceMode: 'Karbantartási mód',
    enableMaintenance: 'Karbantartás engedélyezése',
    disableMaintenance: 'Karbantartás letiltása',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Adatszinkronizálás',
    syncStatus: 'Szinkronizálás állapota',
    lastSync: 'Utolsó szinkronizálás',
    pendingItems: 'Függő elemek',
    syncNow: 'Szinkronizálás most',
    syncing: 'Szinkronizálás...',
    syncSuccess: 'Szinkronizálás sikeresen befejezve',
    syncFailed: 'Szinkronizálás sikertelen',
    outbox: 'Kimenő',
    inbox: 'Bejövő',
    configuration: 'Konfiguráció',
    targetUrl: 'Cél URL',
    apiKey: 'API kulcs',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Térkép',
    layers: 'Rétegek',
    requests: 'Kérelmek',
    hubs: 'Csomópontok',
    facilities: 'Létesítmények',
    routes: 'Útvonalak',
    showAll: 'Összes megjelenítése',
    hideAll: 'Összes elrejtése',
    zoomIn: 'Nagyítás',
    zoomOut: 'Kicsinyítés',
    resetView: 'Nézet visszaállítása',
    satellite: 'Műhold',
    terrain: 'Domborzat',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'A térképcsempék helyi kiszolgálásúak',
    tilesOnline: 'A térképcsempék online szerverekről töltődnek',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statisztikák',
    overview: 'Áttekintés',
    requestsByStatus: 'Kérelmek állapot szerint',
    requestsByCategory: 'Kérelmek kategória szerint',
    requestsByNation: 'Kérelmek állam szerint',
    offersByStatus: 'Ajánlatok állapot szerint',
    patientsByCondition: 'Betegek állapot szerint',
    transportsByStatus: 'Szállítások állapot szerint',
    timeline: 'Idővonal',
    totalRequests: 'Összes kérelem',
    totalOffers: 'Összes ajánlat',
    totalPatients: 'Összes beteg',
    totalTransports: 'Összes szállítás',
    averageResponseTime: 'Átlagos válaszidő',
    completionRate: 'Befejezési arány',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Gyakorlat statisztikái',
    overview: 'Áttekintés',
    byCategory: 'Kategória szerint',
    byNation: 'Állam szerint',
    byDay: 'Nap szerint',
    totalPatientsMoved: 'Összes szállított beteg',
    totalRequestsProcessed: 'Összes feldolgozott kérelem',
    averageProcessingTime: 'Átlagos feldolgozási idő',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Folyamatábra',
    sankey: 'Sankey',
    nodeGraph: 'Csomóponti grafikon',
    refresh: 'Frissítés',
    noData: 'Nincs elérhető folyamatadat',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Névjegy',
    version: 'Verzió',
    systemInfo: 'Rendszerinformáció',
    buildDate: 'Build dátuma',
    environment: 'Környezet',
    description: 'ARCOS — Fejlett kérelemkommunikációs rendszer',
    subtitle: 'Sérültek segítése és orvosi műveletek',
    whatIsArcos: 'Mi az ARCOS? – Magyarázat a gyakorlat résztvevői számára',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Az MMCC-E támogatásával',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – ahol a kíváncsiság találkozik az együttműködéssel.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentáció',
    gettingStarted: 'Első lépések',
    userGuide: 'Felhasználói útmutató',
    faq: 'Gyakran ismételt kérdések',
    troubleshooting: 'Hibaelhárítás',
    apiReference: 'API referencia',
    downloadTemplate: 'Sablon letöltése',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Betegimportálás',
    uploadFile: 'Fájl feltöltése',
    selectFile: 'Fájl kiválasztása',
    preview: 'Előnézet',
    importNow: 'Importálás most',
    importing: 'Importálás...',
    importSuccess: '{{count}} beteg sikeresen importálva',
    importFailed: 'Az importálás sikertelen',
    downloadTemplate: 'Sablon letöltése',
    dragDrop: 'Húzza ide a fájlt, vagy kattintson a kiválasztáshoz',
    supportedFormats: 'Támogatott formátumok: XLSX, XLS, CSV',
    rowsFound: '{{count}} sor találva',
    validRows: '{{count}} érvényes sor',
    invalidRows: '{{count}} érvénytelen sor',
    duplicateRows: '{{count}} ismétlődő sor',
    previewData: 'Adatok előnézete',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Szállítástervezés',
    planRoute: 'Útvonal tervezése',
    routeBuilder: 'Útvonal összeállítása',
    addWaypoint: 'Útpont hozzáadása',
    removeWaypoint: 'Útpont eltávolítása',
    estimatedDuration: 'Becsült időtartam',
    distance: 'Távolság',
    selectVehicle: 'Jármű kiválasztása',
  },

  transportBooking: {
    title: 'Szállításfoglalás',
    bookTransport: 'Szállítás foglalása',
    availableSlots: 'Elérhető időpontok',
    bookingConfirmed: 'Foglalás megerősítve',
    cancelBooking: 'Foglalás törlése',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapacitástervezés',
    totalCapacity: 'Teljes kapacitás',
    usedCapacity: 'Felhasznált kapacitás',
    availableCapacity: 'Elérhető kapacitás',
    utilizationRate: 'Kihasználtsági arány',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Eszközsablonok',
    dayTemplates: 'Napi sablonok',
    createTemplate: 'Sablon létrehozása',
    editTemplate: 'Sablon szerkesztése',
    deleteTemplate: 'Sablon törlése',
    templateName: 'Sablon neve',
    applyTemplate: 'Sablon alkalmazása',
    noTemplates: 'Nem találhatók sablonok',
    confirmDelete: 'Biztosan törölni szeretné ezt a sablont?',
    confirmApply: 'Biztosan alkalmazni szeretné ezt a sablont? Ez felülírja a meglévő adatokat.',
    exportTemplates: 'Sablonok exportálása',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Közleménysor',
    createAnnouncement: 'Közlemény létrehozása',
    editAnnouncement: 'Közlemény szerkesztése',
    deleteAnnouncement: 'Közlemény törlése',
    message: 'Üzenet',
    startTime: 'Kezdési idő',
    endTime: 'Befejezési idő',
    active: 'Aktív',
    noAnnouncements: 'Nincsenek közlemények',
    confirmDelete: 'Biztosan törölni szeretné ezt a közleményt?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Keresés...',
      noResults: 'Nincs találat',
      showing: '{{from}}–{{to}} megjelenítve, összesen {{total}}',
      rowsPerPage: 'Sor oldalanként',
      previousPage: 'Előző oldal',
      nextPage: 'Következő oldal',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Megerősítés',
      cancel: 'Mégse',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Mentetlen módosítások',
      message: 'Mentetlen módosításai vannak. Biztosan el szeretné hagyni ezt az oldalt?',
      stay: 'Maradás az oldalon',
      leave: 'Oldal elhagyása',
    },
    // EmptyState
    emptyState: {
      noData: 'Nincs elérhető adat',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Valami hiba történt',
      message: 'Váratlan hiba történt. Kérjük, próbálja meg frissíteni az oldalt.',
      retry: 'Újrapróbálás',
    },
    // ExportButton
    exportButton: {
      export: 'Exportálás',
      exporting: 'Exportálás...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Nyomtatás',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Vázlat',
      review: 'Felülvizsgálat',
      published: 'Közzétéve',
      selection: 'Kiválasztás',
      inTransit: 'Úton',
      completed: 'Befejezve',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online példány',
      message: 'Csak olvasható mód. Az adatok az elsődleges szerverről szinkronizálódnak.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Megtekintés mint',
      loggedInAs: 'bejelentkezve mint {{nation}}',
      returnTo: 'Visszatérés: {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Oldalak, kérelmek, szállítások keresése...',
      searching: 'Keresés...',
      noResults: 'Nincs találat a következőre: „{{query}}"',
      navigate: 'Navigálás',
      select: 'Kiválasztás',
      close: 'Bezárás',
      pages: {
        dashboard: 'Áttekintés',
        requests: 'Kérelmek',
        transports: 'Szállítások',
        map: 'Térkép',
        myPatients: 'Betegeim',
        flowDiagram: 'Folyamatábra',
        statistics: 'Statisztikák',
        assets: 'Eszközök',
        startPoints: 'Kiindulópontok / Csomópontok',
        treatmentFacilities: 'Egészségügyi létesítmények',
        users: 'Felhasználók',
        settings: 'Beállítások',
        auditLogs: 'Naplózás',
        exerciseControl: 'Gyakorlat vezérlése',
        dataSync: 'Adatszinkronizálás',
        patientImport: 'Betegimportálás',
        notifications: 'Értesítések',
        documentation: 'Dokumentáció',
      },
      actions: {
        importPatientsJson: 'Betegek importálása (JSON)',
        importPatientsExcel: 'Betegek importálása (Excel)',
        importUsers: 'Felhasználók importálása (Excel)',
        importAssetTemplates: 'Eszközsablonok importálása (Excel)',
        importDayTemplates: 'Napi sablon bejegyzések importálása (Excel)',
        exportRequests: 'Kérések exportálása (Excel)',
        exportPatients: 'Betegek exportálása (Excel)',
        exportUsers: 'Felhasználók exportálása (Excel)',
        exportCredentials: 'Hitelesítő adatok exportálása (PDF)',
        exportAuditExcel: 'Naplóbejegyzések exportálása (Excel)',
        exportAuditPdf: 'Naplóbejegyzések exportálása (PDF)',
        pagePatientImport: 'Betegimport oldal',
        pageRequestDetail: 'Kérés részletei oldal',
        pageUsers: 'Felhasználókezelés oldal',
        pageAssetTemplates: 'Eszközsablonok oldal',
        pageDayTemplates: 'Napi sablonok oldal',
        pageRequests: 'Kérések listája oldal',
        pageAuditLogs: 'Naplóbejegyzések oldal',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'A munkamenet lejár',
      message: 'Munkamenete <strong>{{time}}</strong> múlva lejár. Kérjük, mentse munkáját, és jelentkezzen be újra.',
      dismiss: 'Bezárás',
      logoutNow: 'Kijelentkezés most',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Válasszon 4 időzónát',
      configure: 'Időzónák beállítása',
      reset: 'Visszaállítás',
      apply: 'Alkalmazás',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Helyszín kiválasztása',
      latitude: 'Szélesség',
      longitude: 'Hosszúság',
      clickToSelect: 'Kattintson a térképre a helyszín kiválasztásához',
    },
    // Modal
    modal: {
      close: 'Bezárás',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Főoldal',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Rendszerkarbantartás',
    message: 'A rendszer visszaállítás alatt áll a következő gyakorlati napra. Kérjük, várjon a folyamat befejezéséig.',
    autoRefresh: 'Ez az oldal automatikusan frissül, amint a rendszer ismét elérhető.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Legalább 10 karakter',
    uppercase: '1 nagybetű',
    lowercase: '1 kisbetű',
    digit: '1 számjegy',
    special: '1 speciális karakter',
  },
};

export default hu;
